/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cloud_logic_custom: [
    {
      name: 'oshiAPI',
      endpoint:
        'https://p018zqdib0.execute-api.us-east-1.amazonaws.com/devfive',
      region: 'us-east-1',
    },
  ],
  aws_cognito_identity_pool_id:
    'us-east-1:98e9e7b7-6c6b-4e30-8f21-b03a583294d0',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_XA97ViCnJ',
  aws_user_pools_web_client_id: '7hv4fhcqu82k2v0socta6m21qr',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_dynamodb_all_tables_region: 'us-east-1',
  aws_dynamodb_table_schemas: [
    {
      tableName: 'authsessions-devfive',
      region: 'us-east-1',
    },
    {
      tableName: 'cacheddata-devfive',
      region: 'us-east-1',
    },
    {
      tableName: 'extradata-devfive',
      region: 'us-east-1',
    },
    {
      tableName: 'multimediameta-devfive',
      region: 'us-east-1',
    },
    {
      tableName: 'patientactivities-devfive',
      region: 'us-east-1',
    },
    {
      tableName: 'queueschedule-devfive',
      region: 'us-east-1',
    },
  ],
  aws_user_files_s3_bucket: 'multimediaf4a55-devfive',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

export default awsmobile;
